import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import * as moment from 'moment';
import { Constantes } from 'src/app/shared/Constantes/constantes';


@Component({
    selector: 'app-filtro-resumen-guias',
    templateUrl: './filtro-resumen-guias.component.html',
    styleUrls: ['./filtro-resumen-guias.component.css'],
    standalone: false
})
export class FiltroResumenGuiasComponent implements OnInit {
  
  @Input() fechaMinima;
  @Input() fechaMaxima;
  @Input() total;
  
  @Input() classModal: string = Constantes.classCierreModal;
  @Output() eventoFiltrar = new EventEmitter<[string, string]>();
  
  fechaMinimaText = "";
  fechaMaximaText = "";
  

  @ViewChild('contenidoModal') contenidoModal!: TemplateRef<any>;
  dialogRef: MatDialogRef<any>;
  range: UntypedFormGroup;
  formEdicion: UntypedFormGroup;


  constructor(
    private dialog: MatDialog
    
  ) { 

     this.range = new UntypedFormGroup({
          start: new UntypedFormControl(),
          end: new UntypedFormControl(),
        });

    
  }

  ngOnInit(): void {

    this.range.setValue({
    start: this.fechaMinima,
    end: this.fechaMaxima
  });
    
  this.onFiltrar();  
  //this.fechaMinimaText = moment(this.fechaMinima).format('YYYY-MM-DD');
    //this.fechaMaximaText = moment(this.fechaMaxima).format('YYYY-MM-DD');

  }
  
   onOpenModal() {
    this.dialogRef = this.dialog.open(this.contenidoModal, {
      maxWidth: '90%', // Puedes ajustar el ancho según tus necesidades
    });
  }

   onCierrenModal() {
    this.dialogRef.close();
  }


    clearDate(event) {
    this.range.reset();
    event.stopPropagation();
  }

   onFiltrar() {
       this.fechaMinimaText = moment(this.range.value.start).format('YYYY-MM-DD');
       this.fechaMaximaText = moment(this.range.value.end).format('YYYY-MM-DD');
       this.eventoFiltrar.emit([this.fechaMinimaText,this.fechaMaximaText]);
       this.onCierrenModal();
     }

}


